<template>
  <tr style="height: 4rem;">
    <td>
      <b-form-checkbox
        v-if="!dimension.required"
        :id="`${index}-${dimension.value}`"
        :name="`${index}-${dimension.value}`"
        size="lg"
        :checked="isSelected"
        @change="onCheckboxChange"
      />
    </td>
    <td>
      <p class="mb-0" style="line-height: 14px;">
        <BlankIcon v-if="dimension.required" :field="form[dimension.value]" />
        <span style="font-weight: 450">{{ dimension.text }}
          <span v-if="dimension.required" class="asterisk">*</span>
        </span>
      </p>
      <p class="text-muted fs-15 mb-0" style="font-weight: 250;">{{ dimension.description }}</p>
    </td>
    <td>
       <b-input-group append="cm">
         <b-form-input
           v-model.number="form[dimension.value]"
           type="number"
           min="0"
           step="1"
           :disabled="!dimension.required && disabledInput"
         />
       </b-input-group>
    </td>
  </tr>
</template>

<script>
import BlankIcon from '../BlankIcon'

export default {
  name: 'TableRowDimension',
  components: { BlankIcon },
  props: {
    dimension: Object,
    index: Number,
    disabledInput: Boolean,
    selectedDimensions: Array,
    form: Object
  },
  computed: {
    isSelected() {
      return this.selectedDimensions.includes(this.dimension.value)
    }
  },
  methods: {
    onCheckboxChange (checked) {
      let updated = [...this.selectedDimensions]

      if (checked && !updated.includes(this.dimension.value)) {
        updated.push(this.dimension.value)
      } else if (!checked && updated.includes(this.dimension.value)) {
        updated = updated.filter(val => val !== this.dimension.value)
      }

      this.$emit('update:selectedDimensions', updated)
    }
  }
}
</script>
